import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DlSearchBarComponent } from './search-bar/search-bar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [DlSearchBarComponent],
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  exports: [DlSearchBarComponent],
})
export class DlSearchBarModule {}
